module.exports = __webpack_public_path__ + "static/media/03Demo Photo-ink-min.dc235a49.jpeg";